module.exports = __webpack_public_path__ + "static/media/_european-union.c2488419.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_european-union.svg
// module id = 2320
// module chunks = 7